import React from "react";
import { handleCTAClick } from "@website-builder/utilities/utils/DesignUtils.js";

import { Text, Link, LineGraphic } from "@website-builder/ui/shared/elements";
import { ComponentWrapper } from "./style";

const PageNotFound = ({
	heading,
	headingColor,
	description,
	descriptionColor,
	link,
	pageSection,
	lineGraphicColor,
}) => {
	return (
		<ComponentWrapper
			className="page-not-found"
			headingColor={headingColor}
			descriptionColor={descriptionColor}
		>
			<div className="text-wrapper-page-not-found">
				{heading ? (
					<Text variant="headline_0" className="heading">
						{heading}
					</Text>
				) : null}
				{description ? (
					<Text variant="paragraph_L" className="description">
						{description}
					</Text>
				) : null}
				{link ? (
					<Link
						arrowCta
						darkBg={link.bg === "darkBg"}
						onClick={(e) =>
							handleCTAClick(
								link,
								{
									page_section: pageSection,
									redirect_to: link?.link?.link,
									click_text: link?.linkText,
								},
								{},
								e,
							)
						}
					>
						{link.linkText}
					</Link>
				) : null}
			</div>

			<LineGraphic
				line="double_switch"
				stroke={lineGraphicColor || "var(--primary-green-400)"}
				left="0"
				className="line-left"
			/>
			<LineGraphic
				line="single_loop_short"
				stroke={lineGraphicColor || "var(--primary-green-400)"}
				right="0"
				className="line-right"
			/>
		</ComponentWrapper>
	);
};

export default PageNotFound;
